import { useState, useRef,useEffect } from "react";
import BlogTable from "./BlogTable";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { api_url } from "../config/config";
const OurBlogAdmin = ({ }) => {
  const [submittedBlogs, setSubmittedBlogs] = useState([]);
  const [formData, setFormData] = useState({
    blogType: "",
    headline: "",
    subHeadline: "",
    author: "",
    date: "",
    body: "",
    images: [],
  });
  const [blogTypes, setBlogTypes] = useState([]);
  const [blogId, setBlogId] = useState("")
  const [editingIndex, setEditingIndex] = useState(null);
  const [step, setStep] = useState(1);
  const imagesInputRef = useRef(null);
  const apiUrl = api_url

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // const handleImageUpload = (e) => {
  //   const files = e.target.files;
  //   const newImages = [...formData.images];
  
  //   for (let i = 0; i < files.length; i++) {
  //     const file = files[i];
  //     const preview = URL.createObjectURL(file);
  //     const url = "";
  
  //     newImages.push({ preview, url });
  //   }
  
  //   setFormData({
  //     ...formData,
  //     images: newImages,
  //   });
  // };

  const handleImageUpload = async(e) =>{
    const files = e.target.files;
    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]); // Append each file separately
    }
    let blogid = null
    if(editingIndex === null){
      blogid = blogId;
    }else {
      blogid = submittedBlogs[editingIndex].blog_id;
    }
  
    const response = await axios.post(`${apiUrl}/blog-image/${blogid}`, formData, {
      headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` }

    })
    console.log("blog images uploaded",response)
    if(response.status === 200) {
      setFormData({
            ...formData,
            images: response.data.data,
          });
      
        }

  }

  const getBlogTypes = async () => {
    try{
    const response = await axios.get(`${apiUrl}/blog-type`,{
      headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` }

    })
    // setBlogTypes(response.data);
    setBlogTypes(response.data.data);
    console.log("blogTypes", response.data.data);
  } catch (error) {
    console.error("Error fetching blog types:", error);
  } 
}
  useEffect(() => {
    getBlogTypes();
  }, []);
  const handleSaveStep1 = async (e) => {
    e.preventDefault();

    const newFormData = new FormData();
    newFormData.append("title", formData.headline);
    newFormData.append("subtitle", formData.subHeadline);
    newFormData.append("author", formData.author);
    newFormData.append("published_at", formData.date);
    newFormData.append("blog_type_id", formData.blogType);
  
    try {
      let response;
      if (editingIndex !== null) {
        const blogId = submittedBlogs[editingIndex].blog_id;
        response = await axios.patch(`${apiUrl}/blog/${blogId}`, newFormData, {
          headers: { 
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem("admin_token")}` 

           },
        });
      } else {
        response = await axios.post(`${apiUrl}/blog`, newFormData, {
          headers: { 
            "Content-Type": "application/json",
           "Authorization" : `Bearer ${localStorage.getItem("admin_token")}` 

           },
        });
      }
  
      if (response.status === 200 || response.status === 201) {
        // Store blog ID in formData if it's a new blog
        if (editingIndex === null) {
          setFormData((prevData) => ({ ...prevData, id: response.data.id }));

          setBlogId(response.data.blog.blog_id);
        }
        console.log("blog created")
        toast.success("Blog saved successfully!");
        
        setStep(2);
      } else {
        toast.error("Failed to save blog!");
      }
    } catch (error) {
      console.error("Error saving blog:", error);
      toast.error("Something went wrong!");
    }
  };
  

  const handleRemoveImage = (index) => {
    setFormData({
      ...formData,
      images: formData.images.filter((_, i) => i !== index),
    });
  };

  const fetchAllBlogs = async() =>{
    try{
    const response = await axios.get(`${apiUrl}/blog`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` }

    })
    setSubmittedBlogs(response.data.data);
    console.log("blogs fetched", response.data.blogs);
    setSubmittedBlogs(response.data.blogs);
  } catch (error) {
    console.error("Error fetching blogs:", error);
    toast.error("Error fetching blogs!");
  }
  }
  useEffect(() => {
    fetchAllBlogs();
  }, []);

  const handleAddOrUpdateBlog = async(e) => {
    e.preventDefault();
    let blogid = null
    if(editingIndex === null ){
      blogid = blogId
    } else {
      blogid = submittedBlogs[editingIndex].blog_id;
    }  
    const response =  await axios.patch(`${apiUrl}/blog/${blogid}`,
      {
        content: formData.body,  
      },
      {
        headers: {
          'Content-Type': 'application/json',
          
          "Authorization": `Bearer ${localStorage.getItem("admin_token")}` 

        }
      }
    )
    console.log("response of content",response)
    if(response.status === 200) {
      setEditingIndex(null);
      toast.success(`Blog ${editingIndex === null ? `Created`: `Updated`} successfully!`);
      await fetchAllBlogs();     
    } else {
      toast.error("Failed to update blog!");
    }
    if (editingIndex !== null) {
      const updatedBlogs = [...submittedBlogs];
      updatedBlogs[editingIndex] = formData;
      setSubmittedBlogs(updatedBlogs);
      setEditingIndex(null);
    } else {
      setSubmittedBlogs([...submittedBlogs, formData]);
    }

    setFormData({
      blogType: "",
      headline: "",
      subHeadline: "",
      author: "",
      date: "",
      body: "",
      images: [],
    });
    setStep(1);
  };

  const handleDelete = async(index) => {
    try{
    const blogid = submittedBlogs[index].blog_id;
    const response = await axios.delete(`${apiUrl}/blog/${blogid}`,{
      headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` }

    })
    console.log("response of delete",response)
    setSubmittedBlogs(submittedBlogs.filter((_, i) => i !== index));
  } catch (e) {
    console.error("Error deleting blog:", e);
    toast.error("Failed to delete blog!");
  }
  };

  const handleApprove = (index) => {
    const updatedBlogs = [...submittedBlogs];
    updatedBlogs[index].approved = true;
    setSubmittedBlogs(updatedBlogs);
  };

  const handleEdit = (index) => {
  const blog = submittedBlogs[index];
  console.log("edit blog",blog.blog_type,blog.blog_type.blog_type_id);
  const mappedFormData = {
    blogType: blog.blog_type.blog_type_id || "", 
    headline: blog.title || "",
    subHeadline: blog.subtitle || "",
    author: blog.author || "",
    date: blog.published_at 
      ? new Date(blog.published_at).toISOString().split("T")[0] 
      : "", 
    body: blog.content || "",
    images: blog.blog_images || [], 
  };
    setFormData(mappedFormData);
    setEditingIndex(index);
    setStep(1);
  };

  return (
    <div className="p-6 font-poppins bg-gray-100 min-h-screen">
      <BlogTable
        submittedBlogs={submittedBlogs}
        handleDelete={handleDelete}
        handleApprove={handleApprove}
        handleEdit={handleEdit}
      />

      <div
        id="add-new-blog"
        className="bg-white shadow-lg rounded-lg p-6 mt-10"
      >
        <h2 className="text-2xl font-semibold mb-4">
          {editingIndex !== null ? "Edit Blog" : "Create New Blog"}
        </h2>

        {step === 1 && (
  <>
    <div className="mb-4">
      <label className="block font-medium mb-2">Blog Type</label>
      <select
        name="blogType"
        value={formData.blogType}
        onChange={handleInputChange}
        className="w-full p-3 border rounded-lg"
      >
        <option value="">Select a blog type</option>
        {blogTypes.map((type, index) => (
          <option key={index} value={type.blog_type_id}>
            {type.name}
          </option>
        ))}
      </select>
    </div>

    <div className="mb-4">
      <label className="block font-medium mb-2">Headline</label>
      <input
        type="text"
        name="headline"
        value={formData.headline}
        onChange={handleInputChange}
        className="w-full p-3 border rounded-lg"
        placeholder="Enter story headline"
      />
    </div>

    <div className="mb-4">
      <label className="block font-medium mb-2">Subheadline</label>
      <input
        type="text"
        name="subHeadline"
        value={formData.subHeadline}
        onChange={handleInputChange}
        className="w-full p-3 border rounded-lg"
        placeholder="Enter story subheadline"
      />
    </div>

    <div className="mb-4">
      <label className="block font-medium mb-2">Author</label>
      <input
        type="text"
        name="author"
        value={formData.author}
        onChange={handleInputChange}
        className="w-full p-3 border rounded-lg"
        placeholder="Enter author name"
      />
    </div>

    <div className="mb-4">
      <label className="block font-medium mb-2">Date</label>
      <input
        type="date"
        name="date"
        value={formData.date}
        onChange={handleInputChange}
        className="w-full p-3 border rounded-lg"
      />
    </div>
    <div>
      <button className="bg-green-500 text-black py-2 px-4 rounded-lg" onClick={handleSaveStep1}>Save & Next</button>
    </div>
  </>
)}
{step === 2 && (
  <>
    <div className="mb-4">
      <label className="block font-medium mb-2">Images</label>
      <input
        type="file"
        ref={imagesInputRef}
        onChange={handleImageUpload}
        multiple
        className="w-full p-3 border rounded-lg"
      />
      {formData.images?.length > 0 && (
        <div className="mt-2">
          <div className="grid grid-cols-3 gap-4">
            {formData.images.map((img, index) => (
              <div key={index} className="relative">
                <img
                  src={img.image_url}
                  alt={`Uploaded Image ${index}`}
                  className="w-32 h-32 object-cover rounded shadow"
                />
                <div className="mt-2 text-sm">
                  <p>URL: {img.image_url}</p>
                </div>
                <button
                  onClick={() => handleRemoveImage(index)}
                  className="absolute top-2 right-2 text-red-500"
                >
                  &times;
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  </>
)}

{step === 3 && (
  <div className="mb-4">
    <label className="block font-medium mb-2">Body</label>
    <textarea
      name="body"
      value={formData.body}
      onChange={handleInputChange}
      rows="5"
      className="w-full p-3 border rounded-lg"
      placeholder="Write the story content here."
    ></textarea>
  </div>
)}


        {/* Navigation Buttons */}
        <div className="flex justify-between mt-4">
          {step > 1 && (
            <button
              onClick={() => setStep(step - 1)}
              className="bg-gray-500 text-white py-2 px-4 rounded-lg"
            >
              Back
            </button>
          )}
        {step === 2 && (
          <button
            onClick={() => {
              console.log("Next Step:", step + 1);
              setStep(step + 1);
            }}
            className="bg-green-500 text-black py-2 px-4 rounded-lg"
          >
            Next
          </button>
        )}

        {step === 3 && (
          <button
            onClick={handleAddOrUpdateBlog}
            className="bg-green-500 text-black py-2 px-4 rounded-lg"
          >
            {editingIndex !== null ? "Update Blog" : "Submit Blog"}
          </button>
        )}

        </div>
      </div>
      <ToastContainer/>
    </div>
  );
};

export default OurBlogAdmin;
